import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "../../lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setU] = useState("");
  const [password, setP] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [forgotSent, setForgotSent] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("tl_token")) {
      api.get("/admin/me").then(() => navigate("/admin/dashboard")).catch(() => localStorage.removeItem("tl_token"));
    }
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError(null);
    try {
      const { data } = await api.post("/admin/login", { username, password });
      localStorage.setItem("tl_token", data.token);
      navigate("/admin/dashboard");
    } catch (err) { setError(errMsg(err)); }
    setBusy(false);
  };

  const submitForgot = async (e) => {
    e.preventDefault(); setBusy(true); setError(null);
    try {
      await api.post("/admin/forgot-password", { username });
      setForgotSent(true);
    } catch (err) { setError(errMsg(err)); }
    setBusy(false);
  };

  if (forgot) {
    return (
      <div className="login-body adm">
        <div className="login-card">
          <div className="login-brand"><span className="lb-mark">TL</span> AUCTIONS <em>· Control Room</em></div>
          <h1>Reset password</h1>
          {error && <div className="msg err" data-testid="forgot-error">{error}</div>}
          {forgotSent ? (
            <div data-testid="forgot-success">
              <p className="muted" style={{ lineHeight: 1.6 }}>If that account exists, a reset link is on its way to its email inbox. The link works once and expires in 1 hour.</p>
              <button className="btn-primary" onClick={() => { setForgot(false); setForgotSent(false); }} data-testid="forgot-back">Back to sign in</button>
            </div>
          ) : (
            <form onSubmit={submitForgot} data-testid="forgot-form">
              <label>Username (your email)
                <input type="text" value={username} onChange={(e) => setU(e.target.value)} autoComplete="username" required autoFocus data-testid="forgot-username" />
              </label>
              <button type="submit" className="btn-primary" disabled={busy} data-testid="forgot-submit">{busy ? "…" : "Email me a reset link"}</button>
              <button type="button" className="linklike" onClick={() => setForgot(false)} data-testid="forgot-cancel">Back to sign in</button>
            </form>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="login-body adm">
      <div className="login-card">
        <div className="login-brand"><span className="lb-mark">TL</span> AUCTIONS <em>· Control Room</em></div>
        <h1>Sign in</h1>
        {error && <div className="msg err" data-testid="login-error">{error}</div>}
        <form onSubmit={submit} data-testid="login-form">
          <label>Username
            <input type="text" value={username} onChange={(e) => setU(e.target.value)} autoComplete="username" required autoFocus data-testid="login-username" />
          </label>
          <label>Password
            <input type="password" value={password} onChange={(e) => setP(e.target.value)} autoComplete="current-password" required data-testid="login-password" />
          </label>
          <button type="submit" className="btn-primary" disabled={busy} data-testid="login-submit">{busy ? "…" : "Enter"}</button>
          <button type="button" className="linklike" onClick={() => { setForgot(true); setError(null); }} data-testid="forgot-link">Forgot password?</button>
        </form>
      </div>
    </div>
  );
}
